module.exports = __webpack_public_path__ + "static/media/296154.1617c932.jpg";